import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('h1',{staticClass:"text-h3"},[_vm._v("Ducs and Permits")]),_c('p',[_vm._v("Virtual Well uses sophisticated machine learning models to help generate probable reserve estimates of new wells depending on user supplied location and characteristics.")]),_c(VCard,{attrs:{"flat":"","outlined":"","color":"grey"}},[_c(VImg,{attrs:{"eager":"","contain":"","src":require("@/assets/images/virtual.png")}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }